module.exports = __webpack_public_path__ + "static/media/za.03ca5d26.svg";